<template>
  <a-modal title="详情" v-model="visible" :footer="null" width="800px">
    <div>
      <a-button @click="handleCheckBatchNo" type="danger">驳回</a-button>
      <a-button @click="handleCheckBatchOk" type="primary">通过</a-button>
    </div>
    <a-card title="基础信息">
      <div class="labelItem">
        <div>耳标号：</div>
        <div>{{model.tagsNumber}}</div>
      </div>
      <div class="labelItem">
        <div>毛色：</div>
        <div>{{model.coatColor}}</div>
      </div>
      <div class="labelItem">
        <div>月龄：</div>
        <div>{{model.monthOld}}</div>
      </div>
      <div class="labelItem">
        <div>品种：</div>
        <div>{{model.varietyName_dictText}}</div>
      </div>
      <div class="labelItem">
        <div>产犊数：</div>
        <div>
          <a-tooltip>
            {{model.calvingNumber}}
            <a-button icon="search" type="primary" size="small" @click="showBeefCalf()"></a-button>
            <template slot="title">
              只统计终审通过的牛犊数
            </template>
          </a-tooltip>
        </div>
      </div>
      <div class="labelItem">
        <div>当前状态：</div>
        <div>{{model.statusing_dictText}}</div>
      </div>
      <div class="labelItem">
        <div>性别：</div>
        <div>{{model.gender_dictText}}</div>
      </div>
      <div class="labelItem">
        <div>所属养殖户：</div>
        <div>{{model.userId_dictText}}</div>
      </div>
      <div class="labelItem">
        <div>照片：</div>
        <div style="display: flex;flex-wrap: wrap;width: 80%;">
          <template v-for="item of model.photoList">
            <div style="width: 145px;height: auto;margin-left: 5px">
              <!--@click="showPreView(item)"-->
              <img :src="item" style="width: 100%;height: 100%;" :preview="item+new Date().getTime">
            </div>
          </template>
        </div>
      </div>
    </a-card>
    <!--tabPane-->
    <a-card>
      <a-tabs type="card" @change="callback">
        <a-tab-pane key="1" tab="配种记录">
          <div>
            <a-button type="primary" @click="addBreedRecord">新增</a-button>
            <a-table :columns="columnsBreed" :data-source="breedList" :scroll="{x:true}" rowKey="id"
                     :pagination="paginationBreed" @change="tableChange">
              <template slot="action" slot-scope="text,record">
                <a-button shape="round" size="small" type="primary" @click="showCheckModel(record)"
                          :loading="loadingBtn">
                  审核记录
                </a-button>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="产犊记录">
          <div>
            <a-button type="primary" @click="addBeefCalf">新增</a-button>
            <a-table :columns="columnsCal" :scroll="{x:true}" :data-source="calvingList" rowKey="id"
                     :pagination="paginationCalving" @change="tableCalChange">
              <template slot="flag" slot-scope="text,record">
                <a-button shape="round" v-if="'1'==text" style="background-color: #00DB00;color:white;" size="small">
                  正常产犊
                </a-button>
                <a-button shape="round" v-if="'2'==text" style="background-color: #db5f00;color:white;" size="small">
                  早产
                </a-button>
                <a-button shape="round" v-if="'3'==text" style="background-color: #db0000;color:white;" size="small">
                  无配种记录
                </a-button>
                <a-button shape="round" v-if="'4'==text" style="background-color: orange;color:white;" size="small">晚产
                </a-button>
              </template>
              <template slot="action" slot-scope="text,record">
                <a-button shape="round" size="small" type="primary" @click="showCheckCalModel(record)"
                          :loading="loadingBtn">
                  审核记录
                </a-button>
              </template>
            </a-table>

            <beef-cattle-calf-modal ref="calfModelForm" @ok="getCalList()" style="z-index: 1000"></beef-cattle-calf-modal>
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-card>
    <a-card title="操作记录" style="margin-top: 10px;">
      <a-timeline>
        <template v-for="item of checkRecordList">
          <a-timeline-item v-if="item.statusing=='1'&&item.types=='1'">
            <div>{{item.createTime}}</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.user">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  【养殖户】 {{item.user.realname}}
                </div>
                <div style="color: #777777">
                  {{item.remark}}
                </div>
              </div>
              <div
                style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: orange;border-radius: 30px;color: #FFFFFF">
                待初审
              </div>
            </div>
          </a-timeline-item>
          <a-timeline-item v-if="item.statusing=='2'&&item.types=='1'">
            <div>{{item.createTime}}</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.user">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  【养殖户】 {{item.user.realname}}
                </div>
                <div style="color: #777777">
                  {{item.remark}}
                </div>
              </div>
              <div
                style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: #44ff00;border-radius: 30px;color: #FFFFFF">
                初审通过
              </div>
            </div>
            <div style="margin-top: 10px">审核人</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.checkUser">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.checkUser.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  【乡镇管理员】 {{item.checkUser.realname}}
                </div>
                <div style="color: #777777" v-if="item.remark">
                  {{item.remark}}
                </div>
              </div>
              <!--              <div style="margin-left: 10px;" v-if="item.towSignSrc">-->
              <!--                <div style="width: 100px;height: auto;overflow: hidden;">-->
              <!--                  <img :src="item.towSignSrc" style="width: 100%;height: 100%;"/>-->
              <!--                </div>-->
              <!--              </div>-->
            </div>
          </a-timeline-item>
          <a-timeline-item v-if="item.statusing=='3'&&item.types=='1'">
            <div>{{item.createTime}}</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.user">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  【养殖户】 {{item.user.realname}}
                </div>
                <div style="color: #777777">
                  {{item.remark}}
                </div>
              </div>
              <div
                style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: #00ffb7;border-radius: 30px;color: #FFFFFF">
                终审通过
              </div>
            </div>
            <div style="margin-top: 10px">审核人</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.checkUser">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.checkUser.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  【县管理员】 {{item.checkUser.realname}}
                </div>
                <div style="color: #777777" v-if="item.remark">
                  {{item.remark}}
                </div>
              </div>
              <!--              <div style="margin-left: 10px;" v-if="item.couSignSrc">-->
              <!--                <div style="width: 100px;height: auto;overflow: hidden;">-->
              <!--                  <img :src="item.couSignSrc" style="width: 100%;height: 100%;"/>-->
              <!--                </div>-->
              <!--              </div>-->
            </div>
          </a-timeline-item>
          <a-timeline-item v-if="item.statusing=='5'&&item.types=='1'">
            <div>{{item.createTime}}</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.user">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  【养殖户】 {{item.user.realname}}
                </div>
                <div style="color: #777777">
                  {{item.remark}}
                </div>
              </div>
              <div
                style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: red;border-radius: 30px;color: #FFFFFF">
                初审驳回
              </div>
            </div>
            <div style="margin-top: 10px">审核人</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.checkUser">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.checkUser.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  【乡镇管理员】 {{item.checkUser.realname}}
                </div>
                <div style="color: #777777" v-if="item.remark">
                  驳回原因：{{item.remark}}
                </div>
              </div>
            </div>
          </a-timeline-item>
          <a-timeline-item v-if="item.statusing=='6'&&item.types=='1'">
            <div>{{item.createTime}}</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.user">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  【养殖户】 {{item.user.realname}}
                </div>
                <div style="color: #777777">
                  {{item.remark}}
                </div>
              </div>
              <div
                style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: #950000;border-radius: 30px;color: #FFFFFF">
                终审驳回
              </div>
            </div>
            <div style="margin-top: 10px">审核人</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.checkUser">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.checkUser.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  【县管理员】 {{item.checkUser.realname}}
                </div>
                <div style="color: #777777" v-if="item.remark">
                  驳回原因：{{item.remark}}
                </div>
              </div>
            </div>
          </a-timeline-item>
          <!--        <a-timeline-item v-if="item.statusing=='1'&&item.types=='6'">-->
          <!--          <div>{{item.createTime}}</div>-->
          <!--          <div-->
          <!--            style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"-->
          <!--            v-if="item.user">-->
          <!--            <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">-->
          <!--              <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>-->
          <!--            </div>-->
          <!--            <div style="margin-left: 10px;">-->
          <!--              <div>-->
          <!--                {{item.user.realname}}-->
          <!--              </div>-->
          <!--              <div style="color: #777777">-->
          <!--                {{item.remark}}-->
          <!--              </div>-->
          <!--            </div>-->
          <!--            <div-->
          <!--              style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: orange;border-radius: 30px;color: #FFFFFF">-->
          <!--              提交配种记录-->
          <!--            </div>-->
          <!--          </div>-->
          <!--        </a-timeline-item>-->
        </template>
      </a-timeline>
    </a-card>

    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false;">
      <img alt="example" style="width: 100%" :src="previewImage"/>
    </a-modal>
    <a-modal title="配种审核记录" :visible="recordCheckVisible" :footer="null" @cancel="recordCheckVisible=false">
      <a-timeline>
        <template v-for="item of breedCheckList">
          <a-timeline-item v-if="item.statusing=='1'&&item.types=='6'">
            <div>{{item.createTime}}</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.user">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  {{item.user.realname}}
                </div>
                <div style="color: #777777">
                  {{item.remark}}
                </div>
              </div>
              <div
                style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: orange;border-radius: 30px;color: #FFFFFF">
                待初审
              </div>
            </div>
          </a-timeline-item>
          <a-timeline-item v-if="item.statusing=='2'&&item.types=='6'">
            <div>{{item.createTime}}</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.user">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  {{item.user.realname}}
                </div>
                <div style="color: #777777">
                  {{item.remark}}
                </div>
              </div>
              <div
                style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: #44ff00;border-radius: 30px;color: #FFFFFF">
                初审通过
              </div>
            </div>
            <div style="margin-top: 10px">审核人</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.checkUser">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.checkUser.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  {{item.checkUser.realname}}
                </div>
                <div style="color: #777777" v-if="item.remark">
                  {{item.remark}}
                </div>
              </div>
              <div style="margin-left: 10px;" v-if="item.towSignSrc">
                <div style="width: 100px;height: auto;overflow: hidden;">
                  <img :src="item.towSignSrc" style="width: 100%;height: 100%;"/>
                </div>
              </div>
            </div>
          </a-timeline-item>
          <a-timeline-item v-if="item.statusing=='3'&&item.types=='6'">
            <div>{{item.createTime}}</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.user">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  {{item.user.realname}}
                </div>
                <div style="color: #777777">
                  {{item.remark}}
                </div>
              </div>
              <div
                style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: #00ffb7;border-radius: 30px;color: #FFFFFF">
                终审通过
              </div>
            </div>
            <div style="margin-top: 10px">审核人</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.checkUser">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.checkUser.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  {{item.checkUser.realname}}
                </div>
                <div style="color: #777777" v-if="item.remark">
                  {{item.remark}}
                </div>
              </div>
              <div style="margin-left: 10px;" v-if="item.couSignSrc">
                <div style="width: 100px;height: auto;overflow: hidden;">
                  <img :src="item.couSignSrc" style="width: 100%;height: 100%;"/>
                </div>
              </div>
            </div>
          </a-timeline-item>
          <a-timeline-item v-if="item.statusing=='5'&&item.types=='6'">
            <div>{{item.createTime}}</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.user">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  {{item.user.realname}}
                </div>
                <div style="color: #777777">
                  {{item.remark}}
                </div>
              </div>
              <div
                style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: red;border-radius: 30px;color: #FFFFFF">
                初审驳回
              </div>
            </div>
            <div style="margin-top: 10px">审核人</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.checkUser">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.checkUser.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  {{item.checkUser.realname}}
                </div>
                <div style="color: #777777" v-if="item.remark">
                  驳回原因：{{item.remark}}
                </div>
              </div>
            </div>
          </a-timeline-item>
          <a-timeline-item v-if="item.statusing=='6'&&item.types=='6'">
            <div>{{item.createTime}}</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.user">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  {{item.user.realname}}
                </div>
                <div style="color: #777777">
                  {{item.remark}}
                </div>
              </div>
              <div
                style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: #950000;border-radius: 30px;color: #FFFFFF">
                终审驳回
              </div>
            </div>
            <div style="margin-top: 10px">审核人</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.checkUser">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.checkUser.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  {{item.checkUser.realname}}
                </div>
                <div style="color: #777777" v-if="item.remark">
                  驳回原因：{{item.remark}}
                </div>
              </div>
            </div>
          </a-timeline-item>
        </template>
      </a-timeline>
    </a-modal>
    <a-modal title="产犊审核记录" :visible="recordCheckCalVisible" :footer="null" @cancel="recordCheckCalVisible=false">
      <a-timeline>
        <template v-for="item of calCheckList">
          <a-timeline-item v-if="item.statusing=='1'&&item.types=='7'">
            <div>{{item.createTime}}</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.user">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  {{item.user.realname}}
                </div>
                <div style="color: #777777">
                  {{item.remark}}
                </div>
              </div>
              <div
                style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: orange;border-radius: 30px;color: #FFFFFF">
                待初审
              </div>
            </div>
          </a-timeline-item>
          <a-timeline-item v-if="item.statusing=='2'&&item.types=='7'">
            <div>{{item.createTime}}</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.user">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  {{item.user.realname}}
                </div>
                <div style="color: #777777">
                  {{item.remark}}
                </div>
              </div>
              <div
                style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: #44ff00;border-radius: 30px;color: #FFFFFF">
                初审通过
              </div>
            </div>
            <div style="margin-top: 10px">审核人</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.checkUser">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.checkUser.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  {{item.checkUser.realname}}
                </div>
                <div style="color: #777777" v-if="item.remark">
                  {{item.remark}}
                </div>
              </div>
              <div style="margin-left: 10px;" v-if="item.towSignSrc">
                <div style="width: 100px;height: auto;overflow: hidden;">
                  <img :src="item.towSignSrc" style="width: 100%;height: 100%;"/>
                </div>
              </div>
            </div>
          </a-timeline-item>
          <a-timeline-item v-if="item.statusing=='3'&&item.types=='7'">
            <div>{{item.createTime}}</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.user">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  {{item.user.realname}}
                </div>
                <div style="color: #777777">
                  {{item.remark}}
                </div>
              </div>
              <div
                style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: #00ffb7;border-radius: 30px;color: #FFFFFF">
                终审通过
              </div>
            </div>
            <div style="margin-top: 10px">审核人</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.checkUser">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.checkUser.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  {{item.checkUser.realname}}
                </div>
                <div style="color: #777777" v-if="item.remark">
                  {{item.remark}}
                </div>
              </div>
              <div style="margin-left: 10px;" v-if="item.couSignSrc">
                <div style="width: 100px;height: auto;overflow: hidden;">
                  <img :src="item.couSignSrc" style="width: 100%;height: 100%;"/>
                </div>
              </div>
            </div>
          </a-timeline-item>
          <a-timeline-item v-if="item.statusing=='5'&&item.types=='7'">
            <div>{{item.createTime}}</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.user">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  {{item.user.realname}}
                </div>
                <div style="color: #777777">
                  {{item.remark}}
                </div>
              </div>
              <div
                style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: red;border-radius: 30px;color: #FFFFFF">
                初审驳回
              </div>
            </div>
            <div style="margin-top: 10px">审核人</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.checkUser">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.checkUser.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  {{item.checkUser.realname}}
                </div>
                <div style="color: #777777" v-if="item.remark">
                  驳回原因：{{item.remark}}
                </div>
              </div>
            </div>
          </a-timeline-item>
          <a-timeline-item v-if="item.statusing=='6'&&item.types=='7'">
            <div>{{item.createTime}}</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.user">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  {{item.user.realname}}
                </div>
                <div style="color: #777777">
                  {{item.remark}}
                </div>
              </div>
              <div
                style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: #950000;border-radius: 30px;color: #FFFFFF">
                终审驳回
              </div>
            </div>
            <div style="margin-top: 10px">审核人</div>
            <div
              style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
              v-if="item.checkUser">
              <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                <img :src="item.checkUser.avatar" style="width: 100%;height: 100%;"/>
              </div>
              <div style="margin-left: 10px;">
                <div>
                  {{item.checkUser.realname}}
                </div>
                <div style="color: #777777" v-if="item.remark">
                  驳回原因：{{item.remark}}
                </div>
              </div>
            </div>
          </a-timeline-item>
        </template>
      </a-timeline>
    </a-modal>
    <a-modal v-model="visibleBeefCalfList" title="犊牛列表" @ok="visibleBeefCalfList = false" width="80%">
      <beef-cattle-small-list2 ref="beefCattleCalf"></beef-cattle-small-list2>
    </a-modal>
    <a-modal v-model="visibleCheckNo" title="确认驳回吗" @ok="checkPost('6')">
      <a-input type="textarea" v-model="checkRemark" placeholder="请输入驳回原因"></a-input>
    </a-modal>
    <a-modal v-model="visibleBreedRecord" title="新增配种记录" @ok="saveBreedRecord" okText="保存"
             :confirm-loading="loadingBreedRecord">
      <div>
        <div style="display: flex;align-items: center;margin-top: 10px;">
          <div>冻精号|公牛号</div>
          <div style="margin-left: 10px;">
            <a-input v-model="breedRecordModal.bullNumber" placeholder="请输入冻精号或公牛号"></a-input>
          </div>
        </div>
        <div style="display: flex;align-items: center;margin-top: 10px;">
          <div>发情时间</div>
          <div style="margin-left: 10px;">
            <!--            <a-input v-model="breedRecordModal.bullNumber" placeholder="请输入冻精号或公牛号"></a-input>-->
            <j-date placeholder="请选择发情时间" v-model="breedRecordModal.estrusTime" style="width: 100%"/>
          </div>
        </div>
        <div style="display: flex;align-items: center;margin-top: 10px;">
          <div><span style="color:red;">*</span>配种时间</div>
          <div style="margin-left: 10px;">
            <!--            <a-input v-model="breedRecordModal.bullNumber" placeholder="请输入冻精号或公牛号"></a-input>-->
            <j-date placeholder="请选择配种时间" v-model="breedRecordModal.breedTime" style="width: 100%"/>
          </div>
        </div>
        <!--        <div style="display: flex;align-items: center;">-->
        <!--          <div>预产时间</div>-->
        <!--          <div style="margin-left: 10px;">-->
        <!--&lt;!&ndash;            <a-input v-model="breedRecordModal.bullNumber" placeholder="请输入冻精号或公牛号"></a-input>&ndash;&gt;-->
        <!--            <j-date placeholder="请选择发情时间" v-model="model.preTime" style="width: 100%"/>-->
        <!--          </div>-->
        <!--        </div>-->
        <div style="display: flex;align-items: center;margin-top: 10px;">
          <div>流产时间</div>
          <div style="margin-left: 10px;">
            <!--            <a-input v-model="breedRecordModal.bullNumber" placeholder="请输入冻精号或公牛号"></a-input>-->
            <j-date placeholder="请选择流产时间" v-model="breedRecordModal.amblosisTime" style="width: 100%"/>
          </div>
        </div>
      </div>
    </a-modal>
  </a-modal>
</template>

<script>

  import { getAction, postAction } from '@/api/manage'
  import Vue from 'vue'
  import BeefCattleSmallList2 from '../BeefCattleSmallList3'
  import BeefCattleCalfModal from './BeefCattleCalfModal'

  export default {
    components: { BeefCattleCalfModal, BeefCattleSmallList2 },
    data() {
      return {
        model: {},
        validatorRules: {},
        url: {},
        visible: false,
        batchCheck: '/beef/beefCattle/batchCheck',
        tourBreedAdd: '/beef/beefCattle/tourBreedAdd',
        listBeefAll: '/beef/beefCheckRecord/listBeefAll',
        tourBreedList: '/beef/beefBreedRecord/tourBreedList',
        tourCalvingList: '/beef/beefCalving/tourCalvingList',
        checkRecordList: [],
        breedList: [],
        calvingList: [],
        previewVisible: false,
        previewImage: '',
        columnsBreed: [
          {
            title: '冻精号、公牛号',
            dataIndex: 'bullNumber',
            key: 'bullNumber'
          },
          {
            title: '发情时间',
            dataIndex: 'estrusTime',
            key: 'estrusTime'
          },
          {
            title: '配种时间',
            dataIndex: 'breedTime',
            key: 'breedTime'
          },
          {
            title: '预产时间',
            dataIndex: 'preTime',
            key: 'preTime'
          },
          {
            title: '流产时间',
            dataIndex: 'amblosisTime',
            key: 'amblosisTime'
          },
          {
            title: '当前状态',
            dataIndex: 'statusing_dictText',
            key: 'statusing_dictText'
          },
          {
            title: '操作', dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
            align: 'center'
          }
        ],
        columnsCal: [
          {
            title: '冻精号、公牛号',
            dataIndex: 'bullNumber',
            key: 'bullNumber'
          },
          {
            title: '犊牛耳标',
            dataIndex: 'calfNumber',
            key: 'calfNumber'
          },
          {
            title: '产犊日期',
            dataIndex: 'calvingTime',
            key: 'calvingTime'
          },
          {
            title: '正常产犊',
            dataIndex: 'flag',
            key: 'flag',
            scopedSlots: { customRender: 'flag' }
          },
          {
            title: '当前状态',
            dataIndex: 'statusing_dictText',
            key: 'statusing_dictText'
          },
          {
            title: '操作', dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
            align: 'center'
          }
        ],
        paginationBreed: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30', '50', '100', '500', '1000'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条'
          },
          // showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        paginationCalving: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30', '50', '100', '500', '1000'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条'
          },
          // showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        tabsCurrent: '1',
        recordCheckVisible: false,
        breedCheckList: [],
        calCheckList: [],
        recordCheckCalVisible: false,
        loadingBtn: false,
        userInfo: '',
        visibleBeefCalfList: false,
        checkRemark: '',
        visibleCheckNo: false,
        visibleBreedRecord: false,
        breedRecordModal: {},
        loadingBreedRecord: false
      }
    },
    computed: {},
    created() {
      this.userInfo = Vue.ls.get('Login_Userinfo')
    },
    methods: {
      addBeefCalf() {
        this.$refs.calfModelForm.add()
        this.$refs.calfModelForm.setBeefNumber(this.model.tagsNumber)
        this.$refs.calfModelForm.title = '新增犊牛'
        this.$refs.calfModelForm.disableSubmit = false
      },
      addBreedRecord() {
        this.breedRecordModal = {}
        this.visibleBreedRecord = true
      },
      saveBreedRecord() {
        this.breedRecordModal.beefId = this.model.id
        if (!this.breedRecordModal.beefId) {
          this.$message.warn('母牛不存在')
          return
        }
        if (!this.breedRecordModal.breedTime) {
          this.$message.warn('请选择配种时间')
          return
        }
        console.log(this.breedRecordModal)
        this.loadingBreedRecord = true
        postAction(this.tourBreedAdd, this.breedRecordModal).then(() => {
          this.getBreedList()
          this.$message.success('新增成功')
        }).finally(() => {
          this.loadingBreedRecord = false
          this.visibleBreedRecord = false
        })
      },
      handleCheckBatchNo() {
        // this.checkPost('6')
        this.visibleCheckNo = true
      },
      handleCheckBatchOk() {
        this.checkPost('3')
      },
      checkPost(statusing) {
        let ids = []
        let checkStatus = this.userInfo && this.userInfo.userTypes == '3' ? '1' : '2'
        if (this.model.statusing) {
          if (checkStatus === this.model.statusing) {
            ids.push(this.model.id)
          }
        }
        if (ids.length == 0) {
          this.$message.warning('暂无待审核')
          this.visible = false
          return
        }
        this.loadingTag = true
        postAction(this.url.batchCheck, { statusing, ids, remark: this.checkRemark }).then(res => {
          if (res.success) {
            this.$message.success(res.message)
          } else {
            this.$message.warning(res.message)
          }
        }).finally(final => {
          this.visibleCheck = false
          this.loadingTag = false
          this.visibleCheckNo = false
          this.checkUserRows = []
          this.checkRemark = ''
          this.$emit('ok')
        })
      },
      //产犊记录查看审核详情
      showCheckCalModel(record) {
        this.loadingBtn = true
        getAction(this.listBeefAll, { beefId: this.model.id, calvingId: record.id }).then(res => {
          this.loadingBtn = false
          // this.breedList.forEach(item=>{
          //   if(item.id=== record.id){
          //     item.loadingBtn = false
          //   }
          // })
          this.recordCheckCalVisible = true
          this.calCheckList = res.result
        })
      },
      //配种记录查看审核详情
      showCheckModel(record) {
        // this.breedList.forEach(item=>{
        //   if(item.id===record.id){
        //     item.loadingBtn = true
        //   }
        // })
        this.loadingBtn = true
        getAction(this.listBeefAll, { beefId: this.model.id, breedId: record.id }).then(res => {
          this.loadingBtn = false
          // this.breedList.forEach(item=>{
          //   if(item.id=== record.id){
          //     item.loadingBtn = false
          //   }
          // })
          this.recordCheckVisible = true
          this.breedCheckList = res.result
        })
      },
      //产犊记录表格回调
      tableCalChange(e) {
        // console.log('tableCalChange', e)
        this.paginationCalving = e
        this.getBreedCalList()
      },
      //配种记录表格回调
      tableChange(e) {
        // console.log('tableChange', e)
        this.paginationBreed = e
        this.getBreedCalList()
      },
      //tabPane回调
      callback(e) {
        // console.log('callback:', e)
        this.tabsCurrent = e
        this.getBreedCalList()
      },
      //跳转犊牛
      toPages() {
        let pageUrl = '/beef/smallCattle2'
        this.$router.push(pageUrl + '?beefNumber=' + this.model.tagsNumber)
      },
      showBeefCalf(record) {
        this.visibleBeefCalfList = true
        this.$nextTick(() => {
          this.$refs.beefCattleCalf.querySetBeef(this.model)
        })
      },
      //显示预览图
      showPreView(item) {
        this.previewVisible = true
        this.previewImage = item
      },
      //母牛的操作记录
      checkList() {
        getAction(this.listBeefAll, { beefId: this.model.id }).then(res => {
          console.log(this.listBeefAll, res)
          this.checkRecordList = res.result
        })
      },
      getBreedCalList() {
        if (this.tabsCurrent == '1') {
          this.getBreedList()
        }
        if (this.tabsCurrent == '2') {
          this.getCalList()
        }
      },
      //配种记录
      getBreedList() {
        getAction(this.tourBreedList, {
          beefId: this.model.id,
          pageNo: this.paginationBreed.current,
          pageSize: this.paginationBreed.pageSize
        }).then(res => {
          // console.log(this.tourBreedList, res)
          this.breedList = res.result.records
          if (res.result.total) {
            this.paginationBreed.total = res.result.total
          } else {
            this.paginationBreed.total = 0
          }
        })
      },
      //产犊记录
      getCalList() {
        getAction(this.tourCalvingList, {
          beefNumber: this.model.tagsNumber,
          pageNo: this.paginationCalving.current,
          pageSize: this.paginationCalving.pageSize
        }).then(res => {
          // console.log(this.tourCalvingList, res)
          this.calvingList = res.result.records
          if (res.result.total) {
            this.paginationCalving.total = res.result.total
          } else {
            this.paginationCalving.total = 0
          }
        })
      },
      //显示model
      show(record) {
        this.model = record
        if (this.model.photos) {
          this.model.photoList = this.model.photos.split(',')
        }
        this.visible = true
        this.getBreedCalList()
        this.checkList()
      }
    }
  }
</script>

<style>
  .labelItem {
    display: flex;
    color: black;
  }
</style>